import dateToDayMonthYear from '@sdk/utils/dateFormat/dateToDayMonthYear';
import dateToHumanFormat from '@sdk/utils/dateFormat/dateToHumanFormat';
import getRealDate from '@sdk/utils/getRealDate';

import { OutputDateFormatType } from '@web/forms/components/datePicker/datePicker.types';

type UseDatePickerField = {
  outputFormat: OutputDateFormatType;
  date?: Date;
  alwaysOpenOnToday: boolean;
};

export const useDatePickerField = ({
  outputFormat,
  date,
  alwaysOpenOnToday,
}: UseDatePickerField) => {
  const realDate = getRealDate(date);
  const initialDate = date && !alwaysOpenOnToday ? realDate : new Date();

  const getOutput = (date: Date): string => {
    if (outputFormat === OutputDateFormatType.ddMMM) {
      return dateToDayMonthYear(realDate, true);
    }
    if (outputFormat === OutputDateFormatType.ddMMMM) {
      return dateToDayMonthYear(realDate, true, false);
    }
    if (outputFormat === OutputDateFormatType.ddMMMyyyy) {
      return dateToDayMonthYear(realDate);
    }
    if (outputFormat === OutputDateFormatType.ddMMMMyyyy) {
      return dateToDayMonthYear(realDate, false, false);
    }

    return dateToHumanFormat(date);
  };

  const outputDate = date ? getOutput(realDate) : '';

  return { initialDate, outputDate };
};
